<template>
    <div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    :finished-text="finish_text"
                    @load="load_list"
            >
                <div class="item-panel" v-for="(item,index) in list" :key="index" @click="show_detail(item)">
                    <ticket-item :p_ticket="item" />
                </div>
                <van-empty v-if="list.length===0" description="暂无数据" />
            </van-list>
        </van-pull-refresh>

        <van-overlay :show="detailVisible" @click="detail_click">
            <div class="ticket_panel">
                <div class="title">梅唐四季 电子凭证</div>
                <div class="qr"> <img :src="currentInfo.e_ticket_qr_file" /> </div>
                <div class="content">{{currentInfo.code}}</div>
                <div class="content">{{currentInfo.product_name}}</div>
                <div class="content"><van-tag size="large" :type="tagType">{{currentInfo.e_ticket_status_name}}</van-tag></div>
                <div class="content">{{moment.unix(currentInfo.create_time).format('YYYY-MM-DD HH:mm:ss')}}</div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import TicketItem from "./TicketItem";
    
    export default {
        name: "TicketList",
        components: {TicketItem},
        props:{
            p_action:{          //1待使用列表；2已核销列表
                type:Number,
                default:0,
                required:true,
            }
        },
        data(){
            return{
                list:[],
                loading:false,
                finished:false,
                refreshing: false,
                load_qty:10,
                finish_text:'',
                detailVisible:false,
                currentInfo:{},
                tagType:'',
                moment:this.$moment,
            }
        },
        methods:{
            ...mapActions([
                'GetMyETicketList',
            ]),
            show_detail(val){
                // console.log('票据',val);
                this.currentInfo=val;
                this.tagType=this.currentInfo.e_ticket_status==5?'success':'default';
                this.detailVisible=true;
            },
            detail_click(){
                this.detailVisible = false;
                this.load_list();
                console.log('detail clicked!');
            },
            load_list(){
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                this.loading=true;
                let p={
                    show_count:this.load_qty,
                    action:this.p_action,
                    uid:this.$store.getters.getLoginUser.id,
                };
                this.GetMyETicketList(p).then(res=>{
                    this.loading=false;
                    this.list=res.list;
                    if(this.list.length>10){
                        this.finish_text='我是底线';
                    }
                    if(this.load_qty>=res.total){
                        this.finished=true;
                    }else{
                        this.load_qty +=10;
                    }
                });
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;

                // 重新加载数据
                this.load_list();
            },
        },
        mounted() {
            document.body.style.backgroundColor='#F3F4F5';  //设置整页背景色
            this.load_list();
        }
    }
</script>

<style lang="scss" scoped>
    .ticket_panel{
        background-color: #FFFFFF;
        margin: 80px 14px;
        border-radius: 10px;
        .title{
            font-size: 12px;
            color: #666666;
            font-weight: bold;
            text-align: center;
            padding-top: 14px;
        }
        .qr{
            text-align: center;
            padding: 4px;
            img{
                height: 200px;
                width: 200px;
            }
        }
        .content{
            text-align: center;
            padding-left: 10px;
            padding-bottom: 10px;
            font-size: 12px;
            color: #666666;
        }
    }

</style>
